import styled from 'styled-components/macro';

export const OuterWrapper = styled.div``;

export const Content = styled.div`
    text-align: center;
    padding: 6px 10px;
    font-size: 1.1rem;
    // todo: define standard font size for button, or use a design system
    box-sizing: border-box;
    user-select: none;
    font-weight: 500;
`;

export const IconWrapper = styled.div`
    text-align: center;
`;
